import type { ReactNode } from "react";
import { Compass } from "@phosphor-icons/react";
import { EmptyState } from "@ghezaa/ui";
import { useLingui } from "@lingui/react/macro";

/**
 * An address no route matches, shown inside the app's shell (the router's `defaultNotFoundComponent`). The app passes
 * its own way home as the action: the shell has no router of its own.
 */
export function NotFound({ action }: { action?: ReactNode }) {
  const { t } = useLingui();
  return (
    <EmptyState
      icon={Compass}
      title={t`This page does not exist`}
      description={t`The link may be old or mistyped; start again from the home page.`}
      action={action}
    />
  );
}
